// 9fbef606107a605d69c0edbcd8029e5d
import { BIRTHDAY_MODULE_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';
import { createSelector } from 'reselect';

/**
 * Selector function to retur redux getBirthdayModuleHp
 * @param { object } state reduxStore state
 */
export const getBirthdayModuleHp = (state) => state && state?.[BIRTHDAY_MODULE_REDUCER_KEY];
export const getBirthdayChildrenHp = createSelector(
  getBirthdayModuleHp,
  (state) => state && state?.get('BirthdayModuleHP')
);

export const getCD81Data = createSelector(getBirthdayModuleHp, (state) => state && state?.cd81Data);
